(function () {
  const formSelector = 'form[data-rapidmail-newsletter]';
  const successMessage = 'Vielen Dank! Bitte prüfen Sie Ihr Postfach und bestätigen Sie Ihre Anmeldung.';
  const errorMessage = 'Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.';

  function getMessageElement(form) {
    let message = form.querySelector('[data-rapidmail-message]');

    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-rapidmail-message', '');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      form.appendChild(message);
    }

    return message;
  }

  function setMessage(form, text, type) {
    const message = getMessageElement(form);
    message.textContent = text;
    message.className = `rapidmail-newsletter-message rapidmail-newsletter-message--${type}`;
  }

  function extractError(responseText) {
    if (!responseText) return errorMessage;

    try {
      const payload = JSON.parse(responseText);
      const validationMessages = payload.validation_messages || {};
      const firstValidationMessage = Object.values(validationMessages)[0];

      return firstValidationMessage || payload.message || errorMessage;
    } catch (error) {
      return errorMessage;
    }
  }

  function rememberPopupSignup(form) {
    const popupCookieDays = parseInt(form.dataset.popupCookieDays, 10);

    if (!popupCookieDays) return;

    const date = new Date();
    date.setTime(date.getTime() + popupCookieDays * 24 * 60 * 60 * 1000);
    document.cookie = `feinzug_popup_hidden=true; expires=${date.toUTCString()}; path=/`;
  }

  async function submitNewsletter(event) {
    const form = event.target;

    if (!form.matches(formSelector)) return;
    if (!form.checkValidity()) return;

    event.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const previousButtonText = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (previousButtonText.trim()) submitButton.textContent = 'Bitte warten...';
    }

    try {
      const response = await fetch(form.action, {
        method: form.method || 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
        },
      });
      const responseText = await response.text();

      if (response.ok) {
        form.reset();
        rememberPopupSignup(form);
        setMessage(form, successMessage, 'success');
        return;
      }

      setMessage(form, extractError(responseText), 'error');
    } catch (error) {
      setMessage(form, errorMessage, 'error');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        if (previousButtonText.trim()) submitButton.textContent = previousButtonText;
      }
    }
  }

  document.addEventListener('submit', submitNewsletter);
})();
